// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__A+kIW","logo":"MainNavigation_logo__AQtwn","nav":"MainNavigation_nav__E5sx3","active":"MainNavigation_active__A3hGx"};